// @owners { team: patients }
import { getBrand } from '@alto/design-system';
import { ALTO_COMPANY_ID, FUZE_HEALTH_COMPANY_ID } from '~shared/constants';

export const getCompanyID = (): number => (getBrand() === 'fuzehealth' ? FUZE_HEALTH_COMPANY_ID : ALTO_COMPANY_ID);
